import React from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  isHotelItem?: boolean
  hotelName?: string
  size?: 'small' | 'medium' | 'large'
  colour?: App.Design.ContentColour
}

function HotelInclusionLabel({
  hotelName,
  isHotelItem = false,
  size = 'small',
  colour = 'highlight-secondary',
}: Props) {
  const intl = useIntl()
  const hotelInclusionsAppliedLabel = intl.formatMessage({
    id: 'aPhdl7JIV5',
    defaultMessage: 'Hotel inclusions applied',
    description: 'Label indicating hotel inclusions have been applied to this item',
  })
  const includedWithHotelLabel = intl.formatMessage(
    {
      id: '62lRXJ0F4S',
      defaultMessage: 'Included with your {hotelName} stay',
      description: 'Label indicating experience is included with the specified hotel booking',
    },
    { hotelName: hotelName ?? '' },
  )
  const label = isHotelItem ? hotelInclusionsAppliedLabel : includedWithHotelLabel
  return (
    <BodyTextBlock
      variant={size}
      colour={colour}
      data-testid="hotel-inclusion-label"
    >
      {label}
    </BodyTextBlock>
  )
}

export default React.memo(HotelInclusionLabel)
